import React from "react";
import Snackbar from "./../Components/Snackbar/Snackbar";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import SelectDatas from "./../PopUp/SelectData";
import { Grid } from "@mui/material";
import moment from "moment";
export default class data extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messagealert: "",
      Pricelevel: this.props.p2_1,
      SaleDate: this.props.p2_2,
      PriceType: this.props.p2_3,
    };
  }
  SelectSetData = async (type, data) => {
    var data3 = "";
    switch (type) {
      case "Pricelevel":
        data3 = (await type) + "|" + data;
        break;
      case "Calendar1":
        data3 = (await type) + "|" + data;
        break;
      case "PriceType":
        data3 = (await type) + "|" + data;
        break;
      default:
        break;
    }
    this.props.Getdata("data2", data3);
  };
  render() {
    return (
      <Grid container spacing={2}>
        <Grid item sm={12} md={6} lg={4} xl={4}>
          <SelectDatas
            origin="Pricelevel" // กลุ่มลูกค้าหลัก
            valueSelect={(e) => this.SelectSetData("Pricelevel", e)} // รับค่ากลับ
            title="ระดับราคาขาย"
            defaultselect={this.state.Pricelevel} // ค่าเริ่มต้นของ กลุ่มลูกค้าหลัก
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={4}>
          <MaterialUIPickers
            title="วันเกิดลูกค้า"
            DateValue={(e) => this.SelectSetData("Calendar1", e)}
            defaultdate={this.state.SaleDate}
          />
        </Grid>
        <Grid item sm={12} md={6} lg={4} xl={4}>
          <SelectDatas
            origin="PriceType" // ประเภทราคา
            valueSelect={(e) => this.SelectSetData("PriceType", e)} // รับค่ากลับ
            title="ประเภทราคา"
            defaultselect={this.state.PriceType} // ค่าเริ่มต้นของ ประเภทราคา
          />
        </Grid>
        <Snackbar
          place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={this.state.autoClose}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => {
            this.setState({ opensnackbar: false });
          }}
          close
        />
      </Grid>
    );
  }
}
